import React from 'react';
import { Paper, Typography, Stack, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const formatAddress = (addr) => {
    if (!addr) return null;
    return [
        addr.full_name || addr.name,
        addr.line1 || addr.address_line_1 || addr.address,
        addr.line2 || addr.address_line_2,
        [addr.city, addr.state, addr.zip || addr.postal_code].filter(Boolean).join(', '),
        addr.country?.name || addr.country,
        addr.phone,
    ].filter(Boolean);
};

const AddressBlock = ({ titleAr, titleEn, address, isArabic }) => {
    const lines = formatAddress(address);
    if (!lines || lines.length === 0) return null;

    return (
        <Box sx={{ mb: 1.5 }}>
            <Typography variant="subtitle2" fontWeight={700} mb={0.5}>
                {isArabic ? titleAr : titleEn}
            </Typography>
            <Stack spacing={0.25}>
                {lines.map((line, i) => (
                    <Typography key={i} variant="body2" color="text.secondary">
                        {line}
                    </Typography>
                ))}
            </Stack>
        </Box>
    );
};

const OrderAddressesCard = ({ order }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    const shipping = order?.shipping_address || order?.shippingAddress;
    const billing  = order?.billing_address  || order?.billingAddress;
    const sameAddress =
        shipping && billing && (shipping.id === billing.id);

    if (!shipping && !billing) return null;

    return (
        <Paper
            elevation={0}
            sx={{
                p: { xs: 2, md: 2.5 },
                borderRadius: 3,
                border: (t) => `1px solid ${t.palette.divider}`,
                mb: 2,
            }}
        >
            <AddressBlock
                titleAr="عنوان الشحن"
                titleEn="Shipping Address"
                address={shipping}
                isArabic={isArabic}
            />
            {!sameAddress && billing && (
                <AddressBlock
                    titleAr="عنوان الفاتورة"
                    titleEn="Billing Address"
                    address={billing}
                    isArabic={isArabic}
                />
            )}
        </Paper>
    );
};

export default OrderAddressesCard;
